import React from 'react';
import {withRouter} from 'react-router';

import {$t} from '../../helpers/translator';
import moment from "moment";
import _ from "lodash";
import {Link} from 'react-router-dom';
import TimePeriodSelector from "../miscellaneous/TimePeriodSelector/TimePeriodSelector";
import api from "../../helpers/api";
import MultiSelect from "../miscellaneous/MultiSelect/MultiSelect";
import DataTable from "../miscellaneous/DataTable/DataTable";
import Tooltip from "../miscellaneous/Tooltip/Tooltip";
import {connect} from "react-redux";
import {getAreaTypes, getClinics} from "../../store/data-slice";
import Input from "../miscellaneous/Input/Input";
import AddTreatment from "../AddTreatment/AddTreatment";
import Modal from "../miscellaneous/Modal/Modal";
import HasPermission from 'helpers/permissions/HasPermission';

class TreatmentsTable extends React.Component {
    // static propTypes = {
    //     /** Type of user connected to SmartClinic. used for routing links. (2: clinic, 3: chain) */
    //     userType: PropTypes.number,
    //     /** For presenting a specific clinic data. selection of clinic will be disabled. */
    //     clinicId: PropTypes.number,
    //     /** For presenting a specific patient data. */
    //     patientId: PropTypes.number,
    //     /** For presenting a specific staff data. */
    //     staffId: PropTypes.number,
    //     /** Header of table. Fallbacks to 'Treatments' */
    //     platformId: PropTypes.number,
    //     /** Header of table. Fallbacks to 'Treatments' */
    //     header: PropTypes.string,
    // }
    static defaultProps = {
        userType: 2,
        clinicId: 0,
        patientId: 0,
        staffId: 0,
        platformId: 0,
        header: $t('global.menu.treatments')
    }

    constructor(props) {
        super(props);
        const query = new URLSearchParams(props.location.search);

        this.state = {
            addTreatmentModalShow: false,
            addTreatmentsModalKey: 0,
            tableLoading: false,
            payload: {
                clinicId: this.props.clinicId ? this.props.clinicId : '',
                staffId: this.props.staffId ? this.props.staffId : '',
                patientId: this.props.patientId ? this.props.patientId : '',
                platformId: this.props.platformId ? this.props.platformId : '',
                areaId: '',
                is_unfinished: query.get('filter') === 'is_unfinished' ? query.get('value') : '',
                startDate: moment().subtract(1, 'year'),
                endDate: moment(),
                sort: 'id',
                order: 'desc',
                search: '',
                page: 1,
                per_page: 15,
            },
            pagination: null,
            data: [],

            clinicOptions: [{
                label: $t('global.treatments.allClinics'), value: ''
            },],
            selectedClinicOption: [{
                label: $t('global.treatments.allClinics'), value: ''
            },],

            areasOptions: [{
                label: $t('global.treatments.allAreas'), value: ''
            },],
            unfinishedOptions: [
                {label: 'All', value: ''},
                {label: 'Unfinished', value: '1'},
                {label: 'Finished', value: '0'},
            ],
            selectedAreaOption: [{
                label: $t('global.treatments.allAreas'), value: ''
            },],
            selectedUnfinishedOption: [{
                label: 'All', value: ''
            }],
        };
    }

    async componentDidMount() {
        await this.getTreatments();
        await this.getClinics();
        await this.getAreas();
        const query = new URLSearchParams(this.props.location.search);

        if (query.get('filter') === 'is_unfinished') {
            this.setState({
                payload: {
                    ...this.state.payload,
                    is_unfinished: query.get('value'),
                },
                selectedUnfinishedOption: this.state.unfinishedOptions.find(option => option.value === query.get('value')),
            })
        }
    }

    async getClinics() {
        if (this.state.clinicId) {
            return;
        }

        let res = await this.props.dispatch(getClinics());

        let clinics = [...res];
        clinics.unshift({
            value: '',
            label: $t('global.staff.allAreas'),
        })
        this.setState({clinicOptions: clinics});
    }

    async getAreas() {
        let res = await this.props.dispatch(getAreaTypes());

        let areas = [...res];
        areas.unshift({
            value: '',
            label: $t('global.staff.allAreas'),
        })
        this.setState({areasOptions: areas});
    }

    getAPIUrl() {
        let payload = {...this.state.payload};
        payload.startDate = moment(payload.startDate).format('YYYY/MM/DD');
        payload.endDate = moment(payload.endDate).format('YYYY/MM/DD');
        return `treatments?clinic_id=${payload.clinicId}&patient_db_id=${payload.patientId}&staff_db_id=${payload.staffId}&platform_db_id=${payload.platformId}&area_id=${payload.areaId}&sort=${payload.sort}&order=${payload.order}&search=${payload.search}&page=${payload.page}&per_page=${payload.per_page}&startDate=${payload.startDate}&endDate=${payload.endDate}&is_unfinished=${payload.is_unfinished}
        `
    }

    async getTreatments() {
        this.setState({tableLoading: true}, async () => {
            try {
                let payload = {...this.state.payload};
                payload.startDate = moment(payload.startDate).format('YYYY/MM/DD');
                payload.endDate = moment(payload.endDate).format('YYYY/MM/DD');

                let res = await api.get(this.getAPIUrl());

                let pagination = null;
                let data = [];

                if (res && res.status === 200 && res.data.data) {
                    data = this.restructureData(res.data.data.data);
                    pagination = res.data.data.pagination;

                    this.setState({platforms: [], pagination: pagination}, () => {
                        this.setState({
                            data: data,
                            pagination: pagination
                        });
                    })
                }
            } catch (e) {
                console.error('err get platforms:', e);
            } finally {
                this.setState({tableLoading: false});
            }
        });
    }

    restructureData(data) {
        // console.log('>>> userT', userType, userTypeName, this.props.userType === 2 ? 'clinic' : 'chain')

        _.forEach(data, (v, k) => {
            // console.log(v);
            // let firstSubRow = v.treatments && v.treatments.length ? v.treatments[0] : null;
            let lastSubRow = v.treatments && v.treatments.length ? v.treatments[v.treatments.length - 1] : null;

            v.staff_id = v.staff_id ? <Link to={`/staff/${v.staff_id}`}>{v.staff}</Link> :
                <Link to={`/staff/-1`}>N/A</Link>;
            v.patient_id = v.patient_id ?
                <Link to={`/patient/${v.system_patient_id}`}>{v.patient_id}</Link> : 'N/A';

            if (v.machine_id && v.is_platform_associated) {
                v.machine_id = <Link to={`/equipment/platform/${v.machine_id}`}>{v.MachineName}</Link>
            } else if (v.machine_id && !v.is_platform_associated) {
                v.machine_id = <Tooltip content={$t('global.treatments.platformNotAssociated')}>
                    <div>{v.MachineName}</div>
                </Tooltip>
            } else {
                v.machine_id = v.MachineName
            }

            v.applicator_id = v.serialNumber ?
                <Tooltip content={v.handleTypeName}>{v.serialNumber}</Tooltip> : v.handleTypeName;
            v.clinicName = v.clinic_id ? <Link to={`/clinic/${v.clinic_id}`}>{v.clinicName}</Link> :
                v.clinicName;
            v.total_pulses = lastSubRow ? lastSubRow.total_pulses : '-';
            v.area_id = $t('global.areas.' + v.areaName);
            // v.total_time = lastSubRow ? moment.utc(moment(lastSubRow.created_at).diff(moment(v.created_at))).format('HH:mm:ss') : 'NA';
            v.duration = moment.utc(v.duration * 1000).format('HH:mm:ss')
            v.treatment_mode = this.translateTreatmentMode(v.treatment_mode);
            v.grid_id = v.max_grid_id;
            v.created_at = moment(v.created_at).format('ll')

            _.forEach(v.treatments, (subRow, subRowK) => {
                // let prevChildCreatedAt = v.treatments[subRowK - 1] ? v.treatments[subRowK - 1].created_at : v.created_at;

                subRow.area_id = v.area_id;
                subRow.staff_id = v.staff_id;
                subRow.applicator_id = v.serialNumber ?
                    <Tooltip content={v.handleTypeName}>{v.serialNumber}</Tooltip> : v.handleTypeName;
                subRow.patient_id = v.patient_id;
                subRow.applicator_id = v.handleTypeName;
                // subRow.total_time = moment.utc(moment(subRow.created_at).diff(moment(prevChildCreatedAt))).format('HH:mm:ss');
                subRow.duration = moment.utc(subRow.duration * 1000).format('HH:mm:ss')
                subRow.machine_id = v.machine_id;
                subRow.grid_id = subRow.grid_id_value;
            });
        });
        return data;
    }

    translateTreatmentMode(value) {
        switch (value) {
            case 1:
                return 'SHR';
            case 2:
                return 'HR';
            case 3:
                return 'STACK';
            case 4:
                return 'NIR';
        }
    }

    dataTableActionHandler(data) {
        // console.log('dataTableActionHandler', data)
        if (data.key === 'page') {
            let payload = {...this.state.payload};
            payload.page = data.value;

            this.setState({payload: payload}, async () => {
                await this.getTreatments();
            });
        } else if (data.key === 'header') {
            let payload = {...this.state.payload};

            if (payload.sort === data.value) {
                payload.order = payload.order === 'desc' ? 'asc' : 'desc'
            }
            payload.sort = data.value;

            this.setState({payload: payload}, async () => {
                await this.getTreatments();
            });
        }
    }

    datesChangeHandler(data) {
        let payload = {...this.state.payload};
        payload.startDate = data.startDate;
        payload.endDate = data.endDate;
        payload.page = 1;

        this.setState({payload: payload}, async () => {
            await this.getTreatments();
        });
    }

    searchHandler(e) {
        let payload = {...this.state.payload};
        payload.search = e.target.value;
        payload.page = 1;

        this.setState({payload: payload}, async () => {
            await this.getTreatments();
        });
    }

    selectChangeHandler(name, data) {
        let payload = {...this.state.payload};
        let selectedClinicOption = {...this.state.selectedClinicOption};
        let selectedAreaOption = {...this.state.selectedAreaOption};
        let selectedUnfinishedOption = {...this.state.selectedUnfinishedOption};

        if (name === 'clinic') {
            payload.page = 1;
            payload.clinicId = data.value;
            selectedClinicOption = data;
        }

        if (name === 'area') {
            payload.areaId = data.value;
            payload.page = 1;
            selectedAreaOption = data;
        }

        if (name === 'unfinished') {
            payload.is_unfinished = data.value;
            payload.page = 1;
            selectedUnfinishedOption = data;
        }

        this.setState({
            payload: payload,
            selectedClinicOption: selectedClinicOption,
            selectedAreaOption: selectedAreaOption,
            selectedUnfinishedOption: selectedUnfinishedOption
        }, async () => {
            await this.getTreatments();
        });
    }

    closeModals() {
        this.setState({addTreatmentModalShow: false})
    }

    updateAddTreatmentsModalKey() {
        let state = {...this.state};
        state.addTreatmentsModalKey++;
        this.setState(state)
    }


    render() {
        let tableLoading = this.state.tableLoading;
        let data = this.state.data;
        let pagination = this.state.pagination;
        let tableSorted = {
            id: this.state.payload.sort,
            desc: this.state.payload.order === 'desc'
        }

        let tableHeaders = [
            {
                name: $t('global.treatments.dateAndTime'),
                id: 'created_at',
                clickable: true
            },

            (!this.props.clinicId && this.props.userType !== 2 && !this.props.patientId ?
                {
                    name: $t('global.treatments.clinic'),
                    id: 'clinic_name',
                    clickable: true
                }
                :
                null),
            {
                name: $t('global.treatments.staff'),
                id: 'staff_id',
                clickable: true,
                accessor: 'staff'
            },
            !this.props.patientId && {
                name: $t('global.treatments.patient'),
                id: 'patient_id',
                clickable: true
            },
            {
                name: $t('global.treatments.platform'),
                id: 'machine_id',
                clickable: true,
                accessor: 'MachineName'
            },
            {
                name: $t('global.treatments.applicator'),
                id: 'applicator_id',
                clickable: true,
                accessor: 'handleTypeName'
            },
            {
                name: $t('global.treatments.areaName'),
                id: 'area_id',
                clickable: true,
                accessor: 'areaName'
            },
            {
                name: $t('global.treatments.mode'),
                id: 'treatment_mode',
                exportable: false
            },
            {
                name: $t('global.staff.grid'),
                id: 'grid_id',
                accessor: 'max_grid_id'
            },
            {
                name: $t('global.treatments.pulseCount'),
                id: 'total_pulses',
                exportable: false
            },
            {
                name: $t('global.treatments.fluence'),
                id: 'fluence',
            },
            // {
            //     name: $t('global.treatments.lasingTime'),
            //     id: 'lasing_time',
            // },
            {
                name: $t('global.staff.temperature'),
                id: 'temperature_avg',
            },
            {
                name: $t('global.treatments.energy'),
                id: 'energy',
            },
            {
                name: $t('global.treatments.overallDuration'),
                id: 'duration',
                exportable: false
            },
        ];

        if (this.props.clinicId || this.props.userType === 2 || this.props.patientId) {
            tableHeaders.splice(1, 1);
        }


        return (
            <div className={'container'}>
                <div className={'box'}>
                    <div className={'alma-box'}>
                        <div className={'alma-box-header'}>
                            <h3>{this.props.header}</h3>

                            {false ?
                                <div>
                                    {this.props.userType === 2 ?
                                        <HasPermission permission="treatments.create">
                                            <div className={'secondary-button'}
                                                 onClick={() => this.setState({addTreatmentModalShow: true})}>
                                                {$t('global.treatments.addTreatment')}
                                            </div>
                                        </HasPermission>
                                        :
                                        null
                                    }
                                </div>
                                :
                                null
                            }

                        </div>
                        <div className={'alma-fields-row'}>
                            <div className={'alma-field-container'}>
                                <div className={'alma-field-header'}>{$t('global.staff.selectTimePeriod')}:</div>
                                <TimePeriodSelector startDate={this.state.payload.startDate}
                                                    endDate={this.state.payload.endDate}
                                                    maxDate={this.state.payload.startDate}
                                                    hideQuarters
                                                    onDatesChange={this.datesChangeHandler.bind(this)}/>
                            </div>
                            {
                                !this.props.clinicId && !this.props.patientId && !this.props.staffId && !this.props.platformId && this.props.userType !== 2 ?
                                    <div className={'alma-field-container'}>
                                        <div className={'alma-field-header'}>{$t('global.treatments.byClinic')}</div>

                                        <MultiSelect
                                            options={this.state.clinicOptions}
                                            selected={this.state.selectedClinicOption}
                                            onValueChange={(data) => this.selectChangeHandler('clinic', data)}
                                        />

                                    </div>
                                    :
                                    null
                            }

                            <div className={'alma-field-container'}>
                                <div className={'alma-field-header'}>{$t('global.treatments.byArea')}</div>

                                <MultiSelect
                                    options={this.state.areasOptions}
                                    selected={this.state.selectedAreaOption}
                                    onValueChange={(data) => this.selectChangeHandler('area', data)}
                                />

                            </div>

                            <div className={'alma-field-container'}>
                                <div className={'alma-field-header'}>{$t('global.treatments.byUnfinished')}</div>

                                <MultiSelect
                                    options={this.state.unfinishedOptions}
                                    selected={this.state.selectedUnfinishedOption}
                                    onValueChange={(data) => this.selectChangeHandler('unfinished', data)}
                                />

                            </div>

                            <div className={'alma-field-container'}>
                                <div className={'alma-field-header'}>{$t('global.treatments.search')}</div>
                                <Input name="search"
                                    // disabled={tableLoading}
                                       autoComplete={false}
                                       delay={500}
                                       className={`${'alma-input'}`}
                                       type="text"
                                       value={this.state.payload.search}
                                       placeholder={this.props.userType === 2 ? $t('global.treatments.searchForClinic') : $t('global.treatments.searchForChain')}
                                       onChange={(e) => this.searchHandler(e)}/>
                            </div>
                        </div>

                        <div>
                            <DataTable data={data}
                                       childrenArrayName={'treatments'}
                                       headers={tableHeaders}
                                       pagination={pagination}
                                       loading={tableLoading}
                                       sorted={tableSorted}
                                       apiUrl={this.getAPIUrl()}
                                       onAction={(e) => this.dataTableActionHandler(e)}
                            />
                        </div>
                        <Modal
                            content={<AddTreatment
                                key={this.state.addTreatmentsModalKey}
                                onSuccess={async () => {
                                    this.closeModals();
                                    this.updateAddTreatmentsModalKey();
                                    await this.getTreatments();
                                }}/>}
                            onClose={this.closeModals.bind(this)}
                            visible={this.state.addTreatmentModalShow}/>

                    </div>
                </div>

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    state: state
});

export default withRouter(connect(mapStateToProps)(TreatmentsTable));

